import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { LinePrefillRequest, PrefilledLinesResponse } from '@models/products-and-orders/lines-prefill/lines-prefill.model';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';

@Injectable()
export class LinesPrefillService {
  private readonly url = `${environment.bffUrl}/customer-reports-import-lines`;
  constructor(private httpClient: HttpClient) {}

  getAll(): Observable<PrefilledLinesResponse> {
    return this.httpClient.get<PrefilledLinesResponse>(this.url);
  }

  create(data: LinePrefillRequest): Observable<PrefilledLinesResponse> {
    return this.httpClient.post<PrefilledLinesResponse>(this.url, data);
  }

  validate(): Observable<PrefilledLinesResponse> {
    return this.httpClient.post<PrefilledLinesResponse>(`${this.url}/validate`, undefined);
  }

  apply(): Observable<void> {
    return this.httpClient.post<void>(`${this.url}/apply`, undefined);
  }

  removeAll(): Observable<void> {
    return this.httpClient.delete<void>(this.url);
  }

  remove(id: string): Observable<void> {
    return this.httpClient.delete<void>(`${this.url}/${id}`);
  }
}
